<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <div v-bind="tooltip.attrs" v-on="analise.disabled && tooltip.on">
            <v-btn
              v-on="on"
              outlined
              :color="analise.color"
              :disabled="analise.disabled"
              class="mr-3"
            >
              <slot name="title"></slot>
            </v-btn>
          </div>
        </template>
        É necessáro o preenchimento das informações obrigatórias nos dados
        cadastrais.
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="onClose" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <template v-if="analise.iniciar">
          <v-row>
            <v-col>
              <h3>O envio do contrato assinado é obrigatório.</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-file-input
                accept="application/pdf, application/vnd.ms-excel"
                label="Contrato assinado*"
                v-model="analise.minuta"
                hide-details="auto"
              >
              </v-file-input>
            </v-col>
          </v-row>

          <!-- <v-row style="margin-top: 0">
            <v-col>
              <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-1 w-100 proposta"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.parcela="{ item }">
                  <v-col> 1 </v-col>
                </template>

                <template v-slot:item.custo="{ item }">
                  <v-col> R$ 1000 </v-col>
                </template>

                <template v-slot:item.dataVencimento="{ item }">
                  <v-col>
                    <v-text-field
                      v-model="analise.parcela"
                      outlined
                      label="Data de Vencimento"
                      name="data vencimento"
                      type="text"
                      hide-details="auto"
                      v-mascara="'##/##/####'"
                      placeholder="DD/MM/AAAA"
                    ></v-text-field>
                  </v-col>
                </template>
              </v-data-table>
            </v-col>
          </v-row> -->
        </template>
        <template v-else-if="analise.aceitar">
          <v-row>
            <v-col>
              <strong
                >Custo do Investimento Municipal
                {{
                  payload.investimentoMunicipio &&
                  payload.investimentoMunicipio.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}</strong
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="analise.parcelas"
                label="Quantidade de parcelas"
                placeholder="Selecione.."
                :items="getParcelas(payload.investimentoMunicipio)"
                item-text="label"
                item-value="value"
                hide-details="auto"
                :return-object="true"
              >
                <template slot="no-data"> Nenhuma parcela retornada </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </template>
        <template v-else-if="analise.baixarMinuta">
          <v-row>
            <v-col>
              <h3>
                É necessário adicionar ao menos um representante do SEBRAE/SC
                para gerar a minuta do contrato.
              </h3>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textField
                label="Nome completo do Representante do SEBRAE/SC 1"
                v-model="analise.nomeRepresentante1"
                hide-details="auto"
              >
              </v-textField>
            </v-col>
            <v-col>
              <v-text-field
                label="CPF"
                name="cpf"
                type="text"
                masked
                v-mask="'###.###.###-##'"
                v-model="analise.cpfRepresentante1"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textField
                label="Nome completo do Representante do SEBRAE/SC 2"
                v-model="analise.nomeRepresentante2"
                hide-details="auto"
              >
              </v-textField>
            </v-col>
            <v-col>
              <v-text-field
                label="CPF"
                name="cpf"
                type="text"
                masked
                v-mask="'###.###.###-##'"
                v-model="analise.cpfRepresentante2"
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col>
              <h3>Deseja adicionar uma justificativa a recusa da proposta?</h3>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                label="Justificativa"
                v-model="analise.justificativaRecusa"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn color="error" outlined text @click="onClose">Fechar</v-btn>
        <v-btn
          color="info"
          outlined
          text
          @click="onConfirm"
          :disabled="salvarDisabled"
        >
          <slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { propostaApi } from "@/apis/proposta";
import { statusPropostasEnum } from "./statusPropostasEnum";
import moment from "moment";
export default {
  name: "ModalAnalisarProposta",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
      items: [1, 2],
      analise: this.payload,
      headers: [
        {
          text: "N° da Parcela",
          value: "parcela",
          align: "center",
          width: "10%",
          sortable: false,
        },
        { text: "Custo", value: "custo", align: "center" },
        {
          text: "Data de Vencimento",
          value: "dataVencimento",
          align: "center",
        },
      ],
      headersAnexos: [
        {
          text: "Nome do arquivo",
          value: "filename",
          align: "center",
          width: "10%",
          sortable: false,
        },
        { text: "Excluir", value: "excluir", align: "center" },
      ],
    };
  },
  watch: {
    payload: {
      handler(val) {
        this.analise = val;
        var indexCPf1 = this.analise.nomeRepresentante1.indexOf("-");
        var indexCPf2 = this.analise.nomeRepresentante2.indexOf("-");
        this.analise.nomeRepresentante1 = `${
          indexCPf1 > 0
            ? this.analise.nomeRepresentante1.substring(0, indexCPf1 - 1)
            : this.analise.nomeRepresentante1
        } `;
        this.analise.nomeRepresentante2 = `${
          indexCPf2 > 0
            ? this.analise.nomeRepresentante2.substring(0, indexCPf2 - 1)
            : this.analise.nomeRepresentante2
        } `;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["user"]),
    salvarDisabled() {
      if (this.analise.iniciar && !this.analise.minuta) {
        return true;
      }

      if (
        this.analise.baixarMinuta &&
        !this.analise.nomeRepresentante1 &&
        !this.analise.nomeRepresentante2
      ) {
        return true;
      }

      return false;
    },
  },
  methods: {
    onClose() {
      this.analise = {
        ...this.analise,
        contratoAssinado: null,
        termoAssinado: null,
        parcelas: null,
        nomeRepresentante1: null,
        nomeRepresentante2: null,
      };
      this.dialog = false;
    },

    ...mapActions(["setLoading"]),
    getParcelas(valorTotal) {
      const qtdParcela = this.qtdParcelas(
        new Date(),
        new Date(new Date().getFullYear() + 1, 11)
      );

      const a = Array.from({ length: qtdParcela }).map((item, index) => {
        const qtdParcelaAtual = index + 1;
        const parcelado = valorTotal / qtdParcelaAtual;

        return {
          label: `${qtdParcelaAtual}x de  ${(
            Math.round(parcelado * 100) / 100
          ).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}`,
          value: qtdParcelaAtual,
        };
      });

      return a;
    },
    qtdParcelas(d1, d2) {
      // o ciclo são 24 meses, então o máximo seriam 24 parcelas
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months + 1;
    },
    salvarAnexos() {
      let formData = new FormData();

      formData.append("minuta", this.analise.minuta);
      formData.append("municipioPropostaId", this.analise.municipioPropostaId);
      formData.append("municipioId", this.analise.municipioId);
      formData.append("usuarioCriacao", this.user.usuarioId);
      formData.append("usuarioEnvioMinuta", this.user.usuarioId);

      propostaApi
        .enviarAnexo(formData)
        .then((item) => {
          this.update();
        })
        .catch((err) => {
          this.$notification.error("Erro ao salvar anexo");
          console.log("Erro no salvar anexo ", err);
          this.setLoading(false);
        });
    },
    update() {
      delete this.analise.nomeArquivo;
      delete this.analise.pastaArquivoMinuta;

      propostaApi
        .update(this.analise)
        .then(() => {
          if (this.analise.baixarMinuta) {
            this.$emit("baixarMinuta");
          } else {
            this.$emit("onLoad");
          }

          this.dialog = false;
        })
        .catch((err) => {
          this.$notification.error("Erro ao analisar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    onConfirm() {
      this.setLoading(true);
      if (this.analise.aceitar || this.analise.rejeitar) {
        this.analise.dataAnalise = moment().format("YYYY-MM-DD HH:mm:ss");
        this.analise.qtdParcelas = this.analise.parcelas.value;
        this.analise.usuarioAnalise = this.user.usuarioId;
      }
      if (this.analise.aceitar)
        this.analise.status = statusPropostasEnum.aprovado;
      if (this.analise.rejeitar)
        this.analise.status = statusPropostasEnum.rejeitado;
      if (this.analise.iniciar) {
        this.analise.dataExecucao = moment().format("YYYY-MM-DD HH:mm:ss");
        this.analise.status = statusPropostasEnum.execucaoIniciada;
        this.analise.usuarioExecucao = this.user.usuarioId;
      }
      if (this.analise.baixarMinuta) {
        var indexCPf1 = this.analise.nomeRepresentante1.indexOf("-");
        var indexCPf2 = this.analise.nomeRepresentante2.indexOf("-");

        this.analise.nomeRepresentante1 = `${
          indexCPf1 > 0
            ? this.analise.nomeRepresentante1.substring(0, indexCPf1 - 1)
            : this.analise.nomeRepresentante1
        } - ${this.analise.cpfRepresentante1}`;
        this.analise.nomeRepresentante2 = `${
          indexCPf2 > 0
            ? this.analise.nomeRepresentante2.substring(0, indexCPf2 - 1)
            : this.analise.nomeRepresentante2
        } - ${this.analise.cpfRepresentante2}`;
      }

      if (this.analise.iniciar) {
        this.salvarAnexos();
      } else {
        this.update();
      }
    },
  },
};
</script>
